<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="103" rx="0" ry="0" width="345" height="98" />
        <rect x="15" y="217" rx="0" ry="0" width="163" height="92" />
        <rect x="14" y="315" rx="0" ry="0" width="162" height="20" />
        <rect x="15" y="15" rx="0" ry="0" width="345" height="36" />
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <rect x="15" y="65" rx="0" ry="0" width="44" height="28" />
        <rect x="70" y="67" rx="0" ry="0" width="44" height="22" />
        <rect x="122" y="67" rx="0" ry="0" width="44" height="22" />
        <rect x="174" y="67" rx="0" ry="0" width="44" height="22" />
        <rect x="226" y="66" rx="0" ry="0" width="44" height="22" />
        <rect x="279" y="65" rx="0" ry="0" width="44" height="22" />
        <rect x="328" y="64" rx="0" ry="0" width="29" height="22" />
        <rect x="15" y="341" rx="0" ry="0" width="97" height="20" />
        <rect x="194" y="217" rx="0" ry="0" width="163" height="92" />
        <rect x="193" y="315" rx="0" ry="0" width="162" height="20" />
        <rect x="194" y="341" rx="0" ry="0" width="97" height="20" />
        <rect x="15" y="378" rx="0" ry="0" width="163" height="92" />
        <rect x="14" y="476" rx="0" ry="0" width="162" height="20" />
        <rect x="15" y="502" rx="0" ry="0" width="97" height="20" />
        <rect x="194" y="378" rx="0" ry="0" width="163" height="92" />
        <rect x="193" y="476" rx="0" ry="0" width="162" height="20" />
        <rect x="194" y="502" rx="0" ry="0" width="97" height="20" />
        <rect x="17" y="539" rx="0" ry="0" width="163" height="92" />
        <rect x="16" y="637" rx="0" ry="0" width="162" height="20" />
        <rect x="17" y="663" rx="0" ry="0" width="97" height="20" />
        <rect x="196" y="539" rx="0" ry="0" width="163" height="92" />
        <rect x="195" y="637" rx="0" ry="0" width="162" height="20" />
        <rect x="196" y="663" rx="0" ry="0" width="97" height="20" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/shortVideoListSkeleton.vue